// "앱 정보" - 설치된 앱 버전 표시 + 업데이트 확인 버튼(앱에서만). 실제 업데이트 확인/다이얼로그는
// 네이티브(AppUpdateChecker/AppUpdateDialog)에서 돈다 - 이 버튼은 그 체크를 강제로 한 번 트리거만
// 한다. PushSettings.js/LoginSessions.js/BiometricSettings.js와 같은 자리(프로필 화면) - 2026-10-16.
import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { useSnackbar } from 'notistack';
import { isNative } from '../../lib/biometricLock';
import { getInstalledAppInfo, requestAppUpdateCheck } from '../../lib/appUpdate';

const AppInfoSettings = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [info, setInfo] = useState(null);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    let active = true;
    getInstalledAppInfo().then((i) => {
      if (active) setInfo(i);
    });
    return () => {
      active = false;
    };
  }, []);

  if (!isNative()) {
    return null; // 웹 브라우저: 버전 개념이 없음(항상 최신 배포)
  }

  const handleCheck = async () => {
    setChecking(true);
    try {
      await requestAppUpdateCheck();
      enqueueSnackbar('업데이트 확인을 요청했습니다. 새 버전이 있으면 잠시 후 알림이 뜹니다.', {
        variant: 'info',
      });
    } finally {
      setChecking(false);
    }
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="text.secondary">
          {info ? `버전 ${info.version} (${info.build})` : '버전 정보를 불러오는 중...'}
        </Typography>
        <Button size="small" variant="outlined" disabled={checking} onClick={handleCheck}>
          {checking ? '확인중...' : '업데이트 확인'}
        </Button>
      </Stack>
    </Box>
  );
};

export default AppInfoSettings;
